import React from 'react';
import { Briefcase } from 'lucide-react';
const FEATURED_IMG = 'https://cdn.magicpatterns.com/uploads/tAf6TYiASV1hZmDoDoayNF/Corporate-Planning-Protection-Training.png';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-415">
      <img src={FEATURED_IMG} alt="" className="block absolute inset-0 w-full h-full object-cover" data-id="element-416" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-417" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-418">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-6" data-id="element-419">
          <Briefcase className="w-4 h-4" data-id="element-420" />
          Corporate Solutions
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold text-brand-white tracking-tight leading-tight mb-6 uppercase" data-id="element-421">
          Corporate Planning, Protection, Training{' '}
          <br className="hidden md:block" data-id="element-422" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-teal-light" data-id="element-423">
            and Strategies
          </span>
        </h1>
        <p className="text-lg md:text-xl text-brand-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-424">
          Comprehensive security, investigative, and emergency preparedness
          solutions built to protect your people, your facilities, and your
          operations — anywhere in the world.
        </p>
      </div>
    </section>;
}